export const initialBringFriendValues = {
  parent: {
    name: '',
    email: '',
  },
  friend: {
    name: ''
  }
}